<template>
  <div>
    <h2>
      Empresas
      <el-button
        v-if="canAdd()"
        class="float-left"
        type="primary"
        @click="showDialog()">
        Agregar
      </el-button>
    </h2>
    <app-table
      @change-pagination="onChangePagination"
      @change-search="onChangeSearch"
      :total="total">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%">
        <el-table-column
          prop="name"
          label="Nombre">
        </el-table-column>
        <el-table-column
          prop="description"
          label="Descripción">
        </el-table-column>
        <el-table-column
          :width ="100"
          label="Acciones">
          <template slot-scope="scope">
            <el-button
              v-if="canUpdate()"
              size="mini"
              type="warning"
              @click="showDialog(scope.row)"><i class="el-icon-edit"></i></el-button>
            <el-button
              v-if="!canUpdate() && canShow()"
              size="mini"
              type="primary"
              @click="showDialog(scope.row)"><i class="fa fa-eye"></i></el-button>
            <el-button
              v-if="canDelete()"
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"><i class="el-icon-delete"></i></el-button>
          </template>
        </el-table-column>
      </el-table>
    </app-table>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      center>
      <el-tabs  v-model="activeName" >
        <el-tab-pane label="Nueva Compañía" name="first">
        <el-form ref="form" :model="form" label-width="120px" :rules="rules">
          <el-form-item label="Nombre" prop="name">
            <el-input v-model="form.name"  :disabled="canEditToSave()"></el-input>
          </el-form-item>
          <el-form-item label="Descripción" prop="description">
            <el-input v-model="form.description" :disabled="canEditToSave()"></el-input>
          </el-form-item>
        </el-form>

          <div role="alert" v-if="error.message" class="el-alert el-alert--error">
            <div class="el-alert__content">
              <span class="el-alert__title is-bold">{{ error.message }}</span>
              <p class="el-alert__description">
              <ul>
                <li v-for="item in error.errors">{{ item[0] }}</li>
              </ul>
              </p>
            </div>
          </div>
          <el-alert
            v-if="success"
            title="Se ha guardado exitosamente."
            type="success">
          </el-alert>
          <div  class="dialog-footer float-left">
            <el-button  @click="dialogVisible = false">Cancelar</el-button>
            <el-button type="primary"
                       v-if="!canEditToSave()"
                       :loading="processing"
                       @click="save()">{{actionText}}</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Deducibles" name="second" v-if="form.id">
          <deductibles-table :company_id ="form.id">
          </deductibles-table>
        </el-tab-pane>
        <el-tab-pane label="Provisiones" name="third" v-if="form.id">
          <provisions-table :company_id ="form.id">
          </provisions-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>

</template>

<script>
  import AppTable from '../../components/Table'
  import {baseApi} from '../../configs/urls'
  import BaseCrud from '../../components/abstract/BaseCrud'
  import DeductiblesTable from './DeductiblesTable.vue'
  import ProvisionsTable from './ProvisionsTable.vue'
  export default {
    extends: BaseCrud,
    name: 'company-list',
    components: {
      AppTable, DeductiblesTable, ProvisionsTable
    },
    data () {
      return {
        baseUrl: baseApi + '/companies',
        form: {
          name: '',
          description: ''
        },
        state1: '',
        activeName: 'first',
        dialogTitle: 'Agregar Empresa',
        basePermission: 'companies',
        rules: {
          name: [{ required: true, message: 'El nombre es requerido', trigger: 'blur' }],
          description: [{ required: true, message: 'La descripción es requerida', trigger: 'blur' }]
        }
      }
    },
    methods: {
      querySearch (queryString, cb) {
        const links = this.deductibles
        let results = queryString ? links.filter(this.createFilter(queryString)) : links
        // call callback function to return suggestions
        cb(results)
      },
      createFilter (queryString) {
        return (item) => {
          return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      loadAll () {
      },
      handleSelect (item) {
      },
      _mounted () {
        this.loadAll()
      }
    }
  }
</script>
<style>
  .float-left{
    float: right;
  }
  .text-center{
    text-align: center;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/views/companies/Index.vue